import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import '../styles/EditModal.css';

function ChangePasswordModal({ onClose }) {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate passwords match
    if (formData.newPassword !== formData.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }

    // Validate password length
    if (formData.newPassword.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }

    setSubmitting(true);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/auth/change-password`,
        {
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        toast.success('✅ Password changed successfully!');
        onClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to change password');
      console.error('Error changing password:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div className="edit-modal-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="edit-modal-header">
          <h2>🔐 Change Password</h2>
          <button onClick={onClose} className="close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="edit-form">
          
          <div className="form-group">
            <label>Current Password *</label>
            <input
              type="password"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              required
              disabled={submitting}
              placeholder="Enter your current password"
            />
          </div>

          <div className="form-group">
            <label>New Password *</label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              required
              disabled={submitting}
              placeholder="Enter new password (min 8 characters)"
            />
            <span className="field-hint">🔒 Minimum 8 characters</span>
          </div>

          <div className="form-group">
            <label>Confirm New Password *</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              disabled={submitting}
              placeholder="Re-enter new password"
            />
          </div>

          <div className="edit-form-actions">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={submitting}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-primary"
              disabled={submitting}
            >
              {submitting ? '⏳ Changing...' : '🔐 Change Password'}
            </button>
          </div>

        </form>

      </div>
    </div>
  );
}

export default ChangePasswordModal;